import { useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import ServerDiscovery from '../services/ServerDiscovery';
import { getToken, getUser, setSession } from '../utils/auth';

function AuthUnsubscribeDaily() {
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState('working'); // working | ok | error
  const [message, setMessage] = useState('Unsubscribing from daily Langle emails…');

  useEffect(() => {
    const token = searchParams.get('token');
    if (!token) {
      setStatus('error');
      setMessage('This unsubscribe link is missing a token.');
      return undefined;
    }
    let cancelled = false;
    (async () => {
      try {
        const base = await ServerDiscovery.discoverHttpBase();
        const res = await fetch(`${base}/auth/unsubscribe-daily`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ token }),
        });
        const data = await res.json().catch(() => ({}));
        if (cancelled) return;
        if (!res.ok) {
          setStatus('error');
          setMessage(
            typeof data.detail === 'string'
              ? data.detail
              : 'Invalid or expired unsubscribe link.',
          );
          return;
        }
        if (data.user && getToken()) {
          setSession(getToken(), { ...getUser(), ...data.user });
        }
        setStatus('ok');
        setMessage(data.message || "You're unsubscribed from daily Langle emails.");
      } catch {
        if (!cancelled) {
          setStatus('error');
          setMessage('Could not reach the server. Try again in a moment.');
        }
      }
    })();
    return () => { cancelled = true; };
  }, [searchParams]);

  return (
    <div className="lng-page">
      <header className="lng-topbar">
        <Link to="/" className="lng-back" aria-label="Back to LangShazam">←</Link>
        <h1 className="lng-brand">LangShazam</h1>
        <div className="lng-topbar-actions" />
      </header>
      <section className="lng-auth-card">
        <h2 className="lng-modal-title">
          {status === 'working' ? 'Updating…' : status === 'ok' ? 'Unsubscribed' : 'Couldn’t unsubscribe'}
        </h2>
        <p className="lng-verify-hint">{message}</p>
        {status !== 'working' && (
          <p className="lng-auth-switch">
            <Link to="/account">Account preferences</Link>
            {' · '}
            <Link to="/langle">Play Langle</Link>
          </p>
        )}
      </section>
    </div>
  );
}

export default AuthUnsubscribeDaily;
